import { gettext } from '@eventbrite/i18n';
import { MenuIcon } from '@eventbrite/marmalade';
import classnames from 'classnames';
import React from 'react';
import { useGlobalNavContext } from '../../state';
import { Logo, SearchBar } from '../common';
import { NavLink } from '../common/components/Links/NavLink';
import styles from './MobileNav.module.scss';

const MobileNav = () => {
    const { positionSticky, env } = useGlobalNavContext();
    //TODO: Add default props for mobile navigation once dropdown is finished
    // const { mobile } = navigation ?? {};
    //const serverUrl = env?.serverUrl ?? '';
    const isSticky = positionSticky?.mobile ? 'mobileSticky' : '';
    const navClass = classnames(styles.nav, isSticky);

    return (
        <nav data-testid="mobile-nav" className={navClass}>
            <ul className={styles.root}>
                <li className={styles.logo}>
                    <Logo />
                </li>
                <li className={styles.searchBar}>
                    <SearchBar />
                </li>

                <li className={styles.right}>
                    <ul className={styles.linkContainer}>
                        <li className={styles.listLink}>
                            <NavLink
                                path={env?.loginUrl ?? '/signin/'}
                                text={gettext('Log In')}
                                className={styles.login}
                            />
                        </li>
                        <li className={styles.listLink}>
                            <NavLink
                                path={env?.signupUrl ?? '/signin/signup/'}
                                text={gettext('Sign Up')}
                                className={styles.signup}
                            />
                        </li>
                        {/**TODO: Replace with proper hamburger icon used for dropdown component */}
                        <li className={styles.listLink}>
                            <MenuIcon size="small" />
                        </li>
                    </ul>
                </li>
            </ul>
        </nav>
    );
};

export default MobileNav;
